import type { FormData, FormInputData, PageData } from '../../../../_metronic/helpers/utils/types';

export const careerData: PageData = [
  {
    formId: 'form1',
    heading: 'Career Section',
    data: [
      { id: 'metaName', label: 'Meta title', type: 'input' },
      { id: 'metaContent', label: 'Meta description', type: 'input' },
      { id: 'title', label: 'Career Title', type: 'input' },
      { id: 'subtitle', label: 'Career Subtitle', type: 'input' },
      { id: 'detailTitle', label: 'Career detail Title', type: 'input' },
      { id: 'applyNowText', label: 'Apply now text', type: 'input' },
      { id: 'applyNowText2', label: 'Apply for this job text', type: 'input' },
      { id: 'location', label: 'Location text', type: 'input' },
      { id: 'noJobsText', label: 'No jobs available text', type: 'input' }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'Job opportunities',
    data: [
      { id: 'jobTitle', label: 'Job title', type: 'input' },
      { id: 'jobSubtitle', label: 'Job subtitle', type: 'input' },
      { id: 'location', label: 'Location', type: 'input' },
      { id: 'applyLink', label: 'Apply link', type: 'input' },
      {
        id: 'jobOption',
        label: 'External link or job description',
        type: 'dropdown',
        options: ['External Link', 'Job Description']
      },
      {
        id: 'jobDescription',
        label: 'Job description',
        type: 'richTextEditor',
        // Show this field only when jobOption is 'Job Description'
        isShown: (item: FormData) => {
          return item?.jobOption === 'Job Description';
        }
      }
    ]
  }
];
